import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCandidateMostActiveRecentJobs } from "./CandidateMostActiveRecentJobAPI";

const initialState = {
    data: [],
    loading: false,
    error: null,
};

export const fetchCandidateMostActiveRecentJobsAsync = createAsyncThunk("CandidateMostActiveRecentJobs/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchCandidateMostActiveRecentJobs()
            const resp = data?.response;
            if (!resp) {
                throw new Error("Invalid response structure");
            }
            return resp;
        } catch (error) {
            return rejectWithValue(error.message);

        }
    }
)


const CandidateMostActiveRecentJobsSlice = createSlice({
    name: "CandidateMostActiveRecentJobs",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCandidateMostActiveRecentJobsAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(fetchCandidateMostActiveRecentJobsAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                // console.log("data", action.payload);
                state.error = null;
            })
            .addCase(fetchCandidateMostActiveRecentJobsAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            });
    }

})

export const selectCandidateActiveRecentJobs = (state) => state.candidateMostActiveRecentJobs.data
export default CandidateMostActiveRecentJobsSlice.reducer